<template>
  <div>
    <ListaJuegos />
  </div>
</template>

<script>
import ListaJuegos from '@/components/ListaJuegos.vue'

export default {
  name: 'juegos',
  components: {
    ListaJuegos
  }
}
</script>